module.exports = __webpack_public_path__ + "static/media/car-login.ac1e7ee1.jpg";